<template>
	<div class="notification content">
		<component :is="href('/interactions/ads/details').content" />
        <ul class="sources">
            <li v-for="source of href('/interactions/ads/details').meta.sources" :key="source.traffic">
                <a :href="'/?utm_source=' + source.source + '&utm_medium=site&utm_campaign=demo'" :class="source.source">{{source.traffic}}</a>
            </li>
        </ul>
	</div>
</template>

<script>
import hreflang from "@/lib/hreflang";

export default {
	name: "AdsInteraction",
    mixins: [hreflang],
	created() {
		this.document(require("documents/en/interactions/ads-details.md"), "en");
	},
};
</script>

<style scoped lang="less">
@import url("~whitebox-presentation/src/assets/variables.less");
@import url("~whitebox-presentation/src/assets/mixins.less");
@import url("~whitebox-presentation/src/assets/legend.less");

.sources {
    li {
        margin-top: @gap * 1.5;
        list-style: none;
        line-height: 1.5;
        display: inline-block;
        a {
            position: relative;
            display: inline-block;
            color: @gray-50;
            text-decoration: none;
            font-weight: 400;
            font-size: @font-size;
            transition: @transition;
            margin-right: @gap * 2;
            border-radius: @font-size + @gap;
            border: 1px solid @gray-25;
            box-shadow: 0px 5px 10px -8px fade(@gray-75, 15%);
            padding: @gap @gap * 2;
            padding-left: @gap * 5;
            &::before {
                content: '';
                display: block;
                position: absolute;
                top: 50%;
                left: @gap * 2;
                width: @gap * 2;
                height: @gap * 2;
                border-radius: 50%;
                transform: translateY(-50%);
            }

            &:hover {
                box-shadow: 0px 5px 10px -8px @gray-75;
                color: @black;
            }
        }
        a.search::before {
            background-color: @red;
        }
        a.social::before {
            background-color: @blue;
        }
        a.direct::before {
            background-color: @green;
        }
        a.referral::before {
            background-color: @orange;
        }
        a.message::before {
            background-color: @pink;
        }
        a.display::before {
            background-color: @brick;
        }
        a.other::before {
            background-color: @gray;
        }
        a.generic::before {
            background-color: @black;
        }

        span {
            color: @black;
        }
    }
}
</style>
